<template>
  <v-col cols="12" lg="3">
    <h2>{{ title }}</h2>
  </v-col>
  <v-col cols="9" v-if="!isMobile">
    <div class="traco"></div>
  </v-col>
  <v-col cols="12">
    <div class="slider-partners-container">
        <div class="slider-partners">
            <v-icon class="arrow-icon" @click="slideLeft">mdi-chevron-left</v-icon>
            <div class="cards-wrapper" ref="cardsWrapper">

                <CardParceiro
                  v-for="(partner, index) of partners" :key="index"
                  :id="partner.id"
                  :name="partner.name"
                  :image="partner.image"
                  :benefit="partner.benefit"
                  :states="partner.states"
                  :details="partner.details"
                  :rules="partner.rules"
                  :coupon="partner.coupon"
                  :subcategory="partner.subcategory"
                />

            </div>
            <v-icon class="arrow-icon" @click="slideRight">mdi-chevron-right</v-icon>
        </div>
    </div>
  </v-col>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue';
import CardParceiro from './CardParceiro.vue';
import { useDisplay } from 'vuetify';

const { xs } = useDisplay();
const isMobile = xs.value;

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    partners: {
        type: Array,
        required: true,
    },
});

const cardsWrapper = ref(null); // Reference for the cards wrapper element

const slideLeft = () => {
    const wrapper = cardsWrapper.value; // Accessing the value of the reference
    wrapper.scrollLeft -= wrapper.offsetWidth;
}

const slideRight = () => {
    const wrapper = cardsWrapper.value; // Accessing the value of the reference
    wrapper.scrollLeft += wrapper.offsetWidth;
}

onMounted(() => {
  console.log(isMobile);
  window.scrollTo(0,0);
})

</script>

<style scoped lang="scss">
h2 {
    background-color: $verde-opus;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    text-align: center;
  }
.traco {
  margin-top: 24px;
  background-color: $verde-opus;
  height: 2px;
}
.slider-partners-container {
    display: flex;
    flex-direction: column;
    background-color: #e8e4e1;
}
.slider-partners {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    position: relative;
}

.arrow-icon {
    font-size: 48px;
    color: $verde-opus;
    cursor: pointer;
    padding: 0px;
}

.cards-wrapper {
    display: flex;
    overflow-x: hidden;
    width: 100%;
    /*min-width: 335px;*/
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
}

.card-partners {
    scroll-snap-align: start;
    flex-shrink: 0;
}

</style>
